import { inject, Injectable, Injector, runInInjectionContext } from '@angular/core';
import { FsessionService } from '../session/fsession.service';
import { MunicipalityTokenService } from './municipality-token.service';
import { DatabaseService } from '../database/database.service';
import { tap, Subscription, timer } from 'rxjs';
import { updateTokensAndRefresh } from './token-utils';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class TokenRefreshService {
  private refreshSub: Subscription | null = null;

  private fSesionService = inject(FsessionService);
  private municipalityTokenService = inject(MunicipalityTokenService);
  private databaseService = inject(DatabaseService);
  private injector = inject(Injector);
  private msalService = inject(MsalService);
  private router = inject(Router);

  start() {
    this.scheduleRefresh();
  }

  stop() {
    if (this.refreshSub) {
      this.refreshSub.unsubscribe();
      this.refreshSub = null;
    }
  }

  scheduleRefresh() {
    this.stop();
    const exp = Number(this.fSesionService.optenerValor('AccessTokenExp', 'municipality'));
    if (!exp) return;
    const now = Date.now();
    const msBeforeRefresh = exp - now - 5 * 60 * 1000;
    if (msBeforeRefresh <= 0) {
      this.refreshToken();
    } else {
      this.refreshSub = timer(msBeforeRefresh).subscribe(() => this.refreshToken());
    }
  }

  private refreshToken() {
    this.databaseService.municipalityRefreshToken().subscribe({
      next: async ({ accessToken, refreshToken }) => {
        await this.municipalityTokenService.verifyAndStoreToken(accessToken);
        await this.municipalityTokenService.verifyToken(refreshToken);
        updateTokensAndRefresh(
          this.fSesionService,
          this.municipalityTokenService,
          runInInjectionContext(this.injector, () => inject(TokenRefreshService)),
          accessToken,
          refreshToken,
          'schedule',
        );
      },
      error: () => {
        this.stop();
        this.fSesionService.closeSession();
        this.msalService
          .logoutRedirect()
          .pipe(tap(() => this.router.navigate(['/'])))
          .subscribe();
      },
    });
  }
}
